import { BASE_API_URL } from '../envs.js';
import { placeholderDateNow } from '../helpers/tours.js';
import { authFetch, failNotOK, HttpError } from './api-helper.js';
export const DEFAULT_BIKE_SPEED = 22.2;
export const DEFAULT_E_BIKE_SPEED = 19.2;
export const DEFAULT_MOUNTAIN_BIKE_SPEED = 17.1;
export const DEFAULT_E_MOUNTAIN_BIKE_SPEED = 17.1;
export const DEFAULT_HIKE_SPEED = 1.0;
export const DEFAULT_WINTERHIKE_SPEED = 1.0;
export const DEFAULT_SNOWSHOE_SPEED = 1.0;
export const CYCLING_SPEED_LIMITS = {
    velo: [14.1, 19.1, 22.2, 27.8, 31.8],
    e_velo: [13.1, 17.3, 19.9, 24.1, 27.1],
    mountain_biking: [9.4, 14.1, 17.1, 22.1, 25.5],
    e_mountain_biking: [9.4, 14.1, 17.1, 22.1, 25.5],
};
export const BIKE_TYPES = [
    'velo',
    'e_velo',
    'mountain_biking',
    'e_mountain_biking',
];
export const tourTimeCodes = [
    'wander',
    ...BIKE_TYPES,
    'skating',
    'canoeing',
    'winter_hiking',
    'snowshoe_trekking',
    'cross_country_skiing',
    'sledging',
    'no',
];
export const TourColors = {
    red: '#e30613',
    orange: '#f39200',
    yellow: '#ffe500',
    yellowgreen: '#95c11f',
    green: '#009139',
    darkgreen: '#006633',
    lightblue: '#009fe3',
    darkblue: '#0065ae',
    purple: '#662483',
    black: '#1d1d1b',
};
export function getEmptyPOI() {
    return {
        title: '',
        description: '',
        id: undefined,
        photo: undefined,
        geometry: undefined,
        photoValidity: undefined,
        index: undefined,
    };
}
export async function fetchTours() {
    console.log('fetching tours list', BASE_API_URL);
    const response = await authFetch(`${BASE_API_URL}/api/6/tracks`);
    if (!response.ok) {
        throw new HttpError(response.status, `HTTP error! status: ${response.status}`);
    }
    const data = (await response.json()).items;
    return data?.sort((a, b) => a.name.localeCompare(b.name));
}
export async function importTrackFromFile(file) {
    const formDF = new FormData();
    const filename = file.name.replace(/\.[^/.]+$/, '');
    formDF.append('trackfile', file);
    formDF.append('trackname', filename);
    const response = await authFetch(`${BASE_API_URL}/api/6/import_track`, false, {
        method: 'POST',
        body: formDF,
    });
    if (!response.ok) {
        console.log('KO', response.status, response.statusText, response.url);
        const jsonBody = await response.json();
        throw new HttpError(response.status, jsonBody?.message || response.statusText);
    }
    return response.json();
}
export async function fetchTourDetails(id) {
    const response = await authFetch(`${BASE_API_URL}/api/6/tracks/${id}`, true);
    if (!response.ok) {
        throw new HttpError(response.status, `HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    const multiViapointsIndices = data.properties.viapointsIndices;
    delete data.properties.viapointsIndices;
    const multiCoordinates = data.geometry.coordinates;
    console.assert(Number.isFinite(multiCoordinates[0][0][0]));
    const detailedTour = {
        id: data.id,
        properties: data.properties,
        geom: multiCoordinates,
        viapointsIndices: multiViapointsIndices,
        surfacesIndices: data.properties.surfacesIndices,
        pois: undefined,
    };
    return detailedTour;
}
export async function fetchRecordedTourDetails(id) {
    const response = await failNotOK(authFetch(`${BASE_API_URL}/api/6/recordedtracks/${id}`, true));
    if (!response.ok) {
        throw new HttpError(response.status, `HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    const recordedTimes = data.properties.recordedTimes;
    delete data.properties.recordedTimes;
    const multiCoordinates = data.geometry.coordinates;
    console.assert(Number.isFinite(multiCoordinates[0][0][0]));
    const detailedRecordedTour = {
        id: data.id,
        properties: data.properties,
        geom: multiCoordinates,
        pois: undefined,
        recordedTimes,
    };
    return detailedRecordedTour;
}
export function adaptPoiFeatureToDetails(poiFeatures) {
    return poiFeatures
        ? poiFeatures &&
            poiFeatures.map((f) => {
                const poi = f.getProperties();
                poi.id = f.getId();
                return poi;
            })
        : [];
}
export async function fetchTourPoiFeatures(id, type) {
    const response = await authFetch(`${BASE_API_URL}/api/${type === 'normal' ? '6/tracks' : '6/recordedtracks'}/${id}/pois`, true);
    return await response.json();
}
export async function fetchTourAndPois(id, type) {
    let tour;
    let pois = {
        type: 'FeatureCollection',
        features: [],
    };
    if (type === 'recordedtrack') {
        tour = await fetchRecordedTourDetails(id);
    }
    else {
        tour = await fetchTourDetails(id);
        pois = await fetchTourPoiFeatures(id, type);
    }
    return { tour, pois: pois };
}
export async function savePois(id, poisUpdate) {
    const response = await failNotOK(authFetch(`${BASE_API_URL}/api/6/tracks/${id}/pois`, false, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(poisUpdate),
    }));
    return response.json();
}
export async function saveTour(tour) {
    if (!Number.isFinite(tour.viapointsIndices[0][0])) {
        throw new Error('viapoint ko');
    }
    const x = tour.geom[0][0][0];
    if (!(Number.isFinite(x) && x < 1000)) {
        throw new Error('track ko: ' + x);
    }
    if (tour.properties.name?.length < 1) {
        tour.properties.name = placeholderDateNow();
    }
    const body = JSON.stringify({
        type: 'Feature',
        id: tour.id,
        properties: Object.assign({}, tour.properties, {
            viapointsIndices: tour.viapointsIndices,
            surfacesIndices: tour.surfacesIndices,
        }),
        geometry: {
            type: 'MultiLineString',
            coordinates: tour.geom,
        },
    });
    let method, url;
    if (tour.id) {
        method = 'PUT';
        url = `${BASE_API_URL}/api/6/tracks/${tour.id}`;
    }
    else {
        method = 'POST';
        url = `${BASE_API_URL}/api/6/tracks`;
    }
    const response = await failNotOK(authFetch(url, false, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: body,
    }));
    return await response.json();
}
export async function saveTourConfig(bikeSpeed, eBikeSpeed, hikeSpeed, winterhikeSpeed, snowshoeSpeed, mountainbikeSpeed, eMountainbikeSpeed, color, gpsPoints, opacity, timeType, filterId) {
    const method = 'PUT';
    const url = `${BASE_API_URL}/api/4/usersettings`;
    const body = JSON.stringify({
        bicycle_speed: bikeSpeed,
        e_bicycle_speed: eBikeSpeed,
        hike_speed: hikeSpeed,
        winterhike_speed: winterhikeSpeed,
        snowshoe_speed: snowshoeSpeed,
        mountainbike_speed: mountainbikeSpeed,
        e_mountainbike_speed: eMountainbikeSpeed,
        color: color,
        gps_points: gpsPoints,
        opacity: opacity,
        timetype: timeType,
        filterid: filterId,
    });
    await failNotOK(authFetch(url, false, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: body,
    }));
}
export async function fetchFilters() {
    const url = `${BASE_API_URL}/api/6/filters`;
    const response = await failNotOK(authFetch(url));
    return (await response.json()).items;
}
export async function saveOrUpdateFilters(filtersUpdate) {
    const url = `${BASE_API_URL}/api/6/filters`;
    const response = await failNotOK(authFetch(url, false, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(filtersUpdate),
    }));
    return response.json();
}
export async function saveRecordedTourParts(id, properties, pref, filter) {
    const body = JSON.stringify({
        ...properties,
        pref,
        filter: filter ? filter : null,
    });
    const url = `${BASE_API_URL}/api/6/recordedtracks/${id}`;
    const response = await failNotOK(authFetch(url, false, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: body,
    }));
    return response.json();
}
export async function deleteTour(id, tourType) {
    const tourRequestType = tourType === 'normal' ? 'tracks' : 'recordedtracks';
    const url = `${BASE_API_URL}/api/6/${tourRequestType}/${id}`;
    await failNotOK(authFetch(url, false, {
        method: 'DELETE',
    }));
}
export async function duplicateTour(id, name) {
    const url = `${BASE_API_URL}/api/6/tracks/${id}/duplicate`;
    const properties = { name, recordedtrack: false };
    const response = await failNotOK(authFetch(url, false, {
        method: 'POST',
        body: JSON.stringify({ properties }),
    }));
    return response.json();
}
export async function duplicateRecordedTour(id, name) {
    const url = `${BASE_API_URL}/api/6/to_normal_track`;
    const response = await failNotOK(authFetch(url, false, {
        method: 'POST',
        body: JSON.stringify({ id, name }),
    }));
    return response.json();
}
export async function copyTour(id, tourType) {
    const url = `${BASE_API_URL}/api/6/${tourType === 'normal' ? 'tracks' : 'recordedtracks'}/${id}/copy`;
    const response = await failNotOK(authFetch(url, false, {
        method: 'PUT',
    }));
    return response.json();
}
export async function saveTourParts(id, properties, tourType) {
    const body = JSON.stringify({
        ...properties,
    });
    const url = `${BASE_API_URL}/api/6/${tourType === 'normal' ? 'tracks' : 'recordedtracks'}/${id}`;
    const response = await failNotOK(authFetch(url, false, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: body,
    }));
    return response.json();
}
export function compareFilters(a, b) {
    return a.name.localeCompare(b.name);
}
export async function exportTourGps(id, tourType) {
    const url = `${BASE_API_URL}/api/6/${tourType === 'normal' ? 'tracks' : 'recordedtracks'}/${id}/export_gps`;
    const response = await failNotOK(authFetch(url, false));
    return response.blob();
}
export async function postRouteAndSegmentsToTour(lang, land, routeNumber, segmentNumber) {
    const response = await failNotOK(authFetch(`${BASE_API_URL}/api/6/routes_and_segments_to_tour/${lang}/${land}/${routeNumber}/${segmentNumber}`, false, {
        method: 'POST',
    }));
    return response.json();
}
//# sourceMappingURL=api-tours.js.map